exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-cookbook-template-js": () => import("./../../../src/templates/CookbookTemplate.js" /* webpackChunkName: "component---src-templates-cookbook-template-js" */),
  "component---src-templates-topic-template-js": () => import("./../../../src/templates/TopicTemplate.js" /* webpackChunkName: "component---src-templates-topic-template-js" */)
}

